document.addEventListener("DOMContentLoaded", () => {
    const reputonTitle = document.body.querySelector('.reputon-google-reviews-widget .reputon-location-name');
    if (reputonTitle) {
        console.log(reputonTitle.textContent);
    } else {
        console.log("L'élément n'est pas encore disponible");
    }
});